import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-payment-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent implements OnInit {

  @Input() payments: any = null;

  @Input() projects: any = null;
  @Input() show_paging: any = null;
  @Input() show_expander = true;
  @Input() show_checkbox = false;
  /**
   * Array of column keys to hide. Example: ['date','amount'] to hide date and amount columns
   */
  @Input() hideColumns: string[] = [];
  max_per_page = 100;
  today: Date;

  @ViewChild('dt') paymentsTable: Table;
  activePaymentFilterLabels: string[] = [];
  private readonly paymentFilterLabelMap: { [field: string]: string } = {
    title: 'Title',
    status: 'Status',
    amount: 'Amount',
    due_date: 'Due Date',
  };

  onPaymentTableFilter(event: any) {
    this.activePaymentFilterLabels = this.computeActiveFilterLabels(event.filters, this.paymentFilterLabelMap);
  }

  clearPaymentFilters() {
    if (this.paymentsTable) this.clearTableFilters(this.paymentsTable);
    this.activePaymentFilterLabels = [];
  }

  private clearTableFilters(t: Table): void {
    if (!t) return;
    (t as any).tableService.onResetChange();
    if ((t as any).isStateful()) (t as any).clearState();
    (t as any)._filter();
  }

  private computeActiveFilterLabels(filters: any, labelMap: { [field: string]: string }): string[] {
    if (!filters) return [];
    const active: string[] = [];
    for (const field of Object.keys(labelMap)) {
      const raw = filters[field];
      if (!raw) continue;
      const constraints = Array.isArray(raw) ? raw : [raw];
      const hasValue = constraints.some((c: any) => {
        if (c.value === null || c.value === undefined) return false;
        if (Array.isArray(c.value)) return c.value.length > 0;
        if (typeof c.value === 'string') return c.value.trim().length > 0;
        return true;
      });
      if (hasValue) active.push(labelMap[field]);
    }
    return active;
  }

  constructor() { }

  ngOnInit() {}

  async presentDetailsModal(payment) {

  }

}
